import React from 'react';
import { FadeUp } from '../components/AnimatedSection';
import { useLanguage } from '../context/LanguageContext';

const TermsPage = () => {
  const { language, t } = useLanguage();

  const contentEn = (
    <div className="space-y-8 max-w-3xl">
      <section>
        <h2 className="text-2xl font-semibold text-[#F5F5F7] mb-4">General Overview</h2>
        <p className="text-[#86868B] leading-relaxed">
          Welcome to Tivorao. The terms "we" and "our" refer to Tivorao. Tivorao operates this store and website, 
          including all data, content, features, tools, products, and services to provide you, the customer, 
          with a curated shopping experience (the "Services"). Tivorao is powered by Shopify technology.
        </p>
      </section>

      <section>
        <h2 className="text-2xl font-semibold text-[#F5F5F7] mb-4">Access and Account</h2>
        <p className="text-[#86868B] leading-relaxed">
          By accepting these Terms of Service, you represent that you are at least of legal age in your state 
          or province of residence. You are solely responsible for maintaining the security of your account 
          credentials and all activity on your account. You may not transfer, sell, or assign your account.
        </p>
      </section>

      <section>
        <h2 className="text-2xl font-semibold text-[#F5F5F7] mb-4">Our Products</h2>
        <p className="text-[#86868B] leading-relaxed">
          We have made every effort to provide an accurate representation of our products in our online stores. 
          However, please note that colors or appearance may differ due to the type of device you use. We do not 
          guarantee that the products will meet your expectations or be identical to those shown in our online stores.
        </p>
      </section>

      <section>
        <h2 className="text-2xl font-semibold text-[#F5F5F7] mb-4">Orders and Pricing</h2>
        <p className="text-[#86868B] leading-relaxed">
          When you place an order, you are making an offer to purchase. Tivorao reserves the right to accept 
          or reject your order at its sole discretion. Prices, discounts, and promotions are subject to change 
          without notice. Unless expressly stated otherwise, posted prices do not include shipping, handling, 
          customs, or import charges.
        </p>
      </section>

      <section>
        <h2 className="text-2xl font-semibold text-[#F5F5F7] mb-4">Warranty Disclaimer</h2>
        <p className="text-[#86868B] leading-relaxed uppercase text-sm">
          THE BUYER ACKNOWLEDGES THAT THE PRODUCT HAS BEEN PRODUCED, DEVELOPED, AND SHIPPED BY A THIRD PARTY (MANUFACTURER). 
          ANY DISCREPANCY, ERROR, FAILURE, OR MALFUNCTION IS THE EXPRESS RESPONSIBILITY OF THE MANUFACTURER.
        </p>
      </section>

      <section>
        <h2 className="text-2xl font-semibold text-[#F5F5F7] mb-4">Contact</h2>
        <p className="text-[#86868B] leading-relaxed">
          For questions about these Terms of Service, contact us at contact.tivorao@gmail.com
        </p>
      </section>
    </div>
  );

  const contentEs = (
    <div className="space-y-8 max-w-3xl">
      <section>
        <h2 className="text-2xl font-semibold text-[#F5F5F7] mb-4">Descripción General</h2>
        <p className="text-[#86868B] leading-relaxed">
          Le damos la bienvenida a Tivorao. Los términos "nosotros" y "nuestro(s)/nuestra(s)" hacen referencia a Tivorao. 
          Tivorao opera esta tienda y sitio web, incluida toda la información, el contenido, las funciones, las herramientas, 
          los productos y los servicios para brindarle a usted, el cliente, una experiencia de compra seleccionada (los "Servicios"). 
          Tivorao cuenta con tecnología de Shopify.
        </p>
      </section>

      <section>
        <h2 className="text-2xl font-semibold text-[#F5F5F7] mb-4">Acceso y Cuenta</h2>
        <p className="text-[#86868B] leading-relaxed">
          Al aceptar estos Términos del servicio, usted declara que tiene al menos la mayoría de edad prevista 
          en el estado o la provincia en los que reside. Usted es exclusivamente responsable de preservar la 
          seguridad de las credenciales de su cuenta y de toda la actividad de esta. No podrá transferir, 
          vender ni asignar su cuenta a otra persona.
        </p>
      </section>

      <section>
        <h2 className="text-2xl font-semibold text-[#F5F5F7] mb-4">Nuestros Productos</h2>
        <p className="text-[#86868B] leading-relaxed">
          Hemos realizado todos los esfuerzos posibles para ofrecer una representación precisa de nuestros productos 
          en nuestras tiendas online. Sin embargo, debe tener en cuenta que los colores o el aspecto del producto 
          pueden diferir respecto de cómo se ven en su pantalla debido al tipo de dispositivo que utilice.
        </p>
      </section>

      <section>
        <h2 className="text-2xl font-semibold text-[#F5F5F7] mb-4">Pedidos y Precios</h2>
        <p className="text-[#86868B] leading-relaxed">
          Cuando hace un pedido, realiza una oferta de compra. Tivorao se reserva el derecho de aceptar o rechazar 
          su pedido por cualquier motivo a su entera discreción. Los precios, los descuentos y las promociones están 
          sujetos a cambios sin previo aviso. A menos que de forma expresa se determine algo diferente, los precios 
          publicados no incluyen cargos por impuestos, envío, gestión de pedidos, trámites aduaneros ni importación.
        </p>
      </section>

      <section>
        <h2 className="text-2xl font-semibold text-[#F5F5F7] mb-4">Descargo de Responsabilidad de Garantías</h2>
        <p className="text-[#86868B] leading-relaxed uppercase text-sm">
          EL COMPRADOR DECLARA CONOCER QUE EL PRODUCTO HA SIDO PRODUCIDO, DESARROLLADO Y REMITIDO POR PARTE DE UN TERCERO (FABRICANTE). 
          CUALQUIER DISCREPANCIA, ERROR, FALLO, O INCORRECTO FUNCIONAMIENTO ES EXPRESA RESPONSABILIDAD DEL FABRICANTE.
        </p>
      </section>

      <section>
        <h2 className="text-2xl font-semibold text-[#F5F5F7] mb-4">Contacto</h2>
        <p className="text-[#86868B] leading-relaxed">
          Para preguntas sobre estos Términos de Servicio, contáctenos en contact.tivorao@gmail.com
        </p>
      </section>
    </div>
  );

  return (
    <div data-testid="terms-page" className="min-h-screen bg-black">
      <div className="container-apple section-content pt-32">
        <FadeUp>
          <h1 className="text-4xl sm:text-5xl font-semibold tracking-tight mb-4">
            {t('legal.termsTitle')}
          </h1>
          <p className="text-[#86868B] mb-12">{t('legal.lastUpdated')}: December 2025</p>
          {language === 'es' ? contentEs : contentEn}
        </FadeUp>
      </div>
    </div>
  );
};

export default TermsPage;
